import React from "react";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { DENOMINACIONES } from "../constants";
import { FormaPagoDisponible } from "../types";

interface EfectivoDetalleModalProps {
  isOpen: boolean;
  forma: FormaPagoDisponible | null;
  detalle: Record<number, string>;
  totalCalculado: number;
  onChange: (denominacion: number, valor: string) => void;
  onClose: () => void;
  onSave: () => void;
}

const EfectivoDetalleModal = ({
  isOpen,
  forma,
  detalle,
  totalCalculado,
  onChange,
  onClose,
  onSave,
}: EfectivoDetalleModalProps) => {
  const descripcion = forma?.descripcion ? `(${forma.descripcion})` : "";

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered backdrop="static">
      <ModalHeader toggle={onClose}>Desglose de efectivo {descripcion}</ModalHeader>
      <ModalBody>
        <p className="text-muted">Ingresá la cantidad de billetes o monedas para calcular el total automáticamente.</p>
        <div className="table-responsive">
          <Table className="align-middle table-sm">
            <thead className="table-light">
              <tr>
                <th>Denominación</th>
                <th style={{ width: 160 }}>Cantidad</th>
                <th className="text-end" style={{ width: 200 }}>
                  Subtotal
                </th>
              </tr>
            </thead>
            <tbody>
              {DENOMINACIONES.map((denominacion) => {
                const cantidad = detalle[denominacion] ?? "";
                const subtotal = denominacion * Number(cantidad || 0);
                return (
                  <tr key={denominacion}>
                    <td>Gs. {denominacion.toLocaleString("es-PY")}</td>
                    <td>
                      <Input
                        type="number"
                        min="0"
                        value={cantidad}
                        onChange={(event) => onChange(denominacion, event.target.value)}
                        placeholder="Cantidad"
                      />
                    </td>
                    <td className="text-end">Gs. {subtotal.toLocaleString("es-PY")}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className="rounded border p-3 mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <span className="fw-semibold">Total calculado</span>
            <span className="fs-5">Gs. {totalCalculado.toLocaleString("es-PY")}</span>
          </div>
          <small className="text-muted">Este valor se cargará automáticamente en la forma de pago seleccionada.</small>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" type="button" onClick={onClose}>
          Cancelar
        </Button>
        <Button color="primary" type="button" onClick={onSave}>
          Guardar detalle
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EfectivoDetalleModal;
